<div class="card-body" *ngIf="isPageReady">

  <form #form="ngForm">
      <p-divider type="solid" align="left">
        <div>
          <b> {{proximityRole.description}} Rights </b>
        </div>
      </p-divider>
      <div class="flex flex-wrap pb-3">
        <div class="w-1/3 pb-3 cursor-pointer rounded px-1"
          [class.bg-primary-100]="selectedRight === vm"
          *ngFor="let vm of roleRights" (click)="selectRight(vm)">
          <p-checkbox [disabled]="isReadOnly" [(ngModel)]="vm.hasRight" [binary]="true" [name]="vm.right.name"
            inputId="hasRight" [title]="vm.right.description || vm.right.name" (onChange)="toggleRight(vm)"></p-checkbox>
          <label for="hasRight" class="ml-2 cursor-pointer">{{formatName(vm.right.name)}}</label>
        </div>
      </div>
  </form>

  <div *ngIf="selectedRight" class="qb-insight-box mt-1" style="border-radius: 0">
    <div class="font-semibold mb-2">{{ formatName(selectedRight.right.name) }} — Capabilities</div>
    <ul class="list-disc ml-5">
      <li *ngFor="let cap of getSelectedCapabilities()" class="pb-1">{{ cap }}</li>
    </ul>
  </div>
</div>
